import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";

export class IsExistAuthorizedTokenUsecase {
  constructor(private readonly repo: AppAccountSettingRepository) {}

  execute() {
    return this.repo.isExistAuthorizedToken();
  }
}
